import { useContext } from 'react';
import { KlartextEventConfigContext } from '../providers/klartextEventConfig';
import { SimpleListeningAnimation } from './SimpleListeningAnimation';
import { isRecording } from '../utils/elapsedTime';

function ListeningView() {
  const speechConfig = useContext(KlartextEventConfigContext);
  const recording = isRecording(speechConfig);

  return recording ? (
    <div className={'flex h-full flex-col items-center justify-center gap-y-2'}>
      <SimpleListeningAnimation />
      <span className={'text-[.75rem] font-light'}>Listening to the debate</span>
    </div>
  ) : (
    <div className={'flex h-full flex-col items-center justify-center gap-y-2'}>
      <span className={'text-[.75rem] font-light'}>Nothing found</span>
    </div>
  );
}

export default ListeningView;
